import type {
  IDuplicateAccountValidationError,
  TOrderValidationError,
} from "./types"

export const isDuplicateAccountError = (
  error: TOrderValidationError,
): error is IDuplicateAccountValidationError =>
  error.failed_attribute === "DuplicateAccountValidation"
